export const GraphicPicker = Symbol.for('GraphicPicker');
export const PickerService = Symbol.for('PickerService');

export const BoundsPicker = Symbol.for('BoundsPicker');
export const GlobalPickerService = Symbol.for('GlobalPickerService');

// 拦截器
export const PickItemInterceptor = Symbol.for('PickItemInterceptor');
// pickService的拦截器
export const PickServiceInterceptor = Symbol.for('PickServiceInterceptor');
